// import React from "react";
// import "./Footer.css";
// import Wave from "../../img/wave.png";
// import Insta from "@iconscout/react-unicons/icons/uil-instagram";
// import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
// // import Gitub from "@iconscout/react-unicons/icons/uil-github";

// const Footer = () => {
//   return (
//     <div className="footer">
//       <img src={Wave} alt="" style={{ width: "100%" }} />
//       <div className="f-content">
//         <span>info@sweventradingplc.com</span>
//         <div className="f-icons">
//           <Insta color="white" size={"3rem"} />
//           <Facebook color="white" size={"3rem"} />
//           {/* <Gitub color="white" size={"3rem"} /> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;
import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import logo from "../../img/logo-no-background.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import { Link } from "react-scroll";

const CONTACT = {
  email: "info@sweventradingplc.com",         
  address: "Addis Ababa, Ethiopia",
  hours: "Mon–Fri • 3:00–11:00 Local Time",  
};

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
 
      <div className="f-content">
        <div className="f-brand">
          <img src={logo} alt="Sweven Trading PLC logo" className="f-logo" />
          <div>
            <div className="f-name">Sweven Trading PLC</div>
            <div className="f-tagline">Web & Mobile App Development in Ethiopia</div>
          </div>
        </div>

        <div className="f-contact">
          <h4>Contact</h4>
          <ul>
            <li>
              <span>📧</span>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </li>
            {/* <li>
              <span>📞</span>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}>{CONTACT.phone}</a>
            </li> */}
            <li>
              <span>📍</span>
              <address>{CONTACT.address}</address>
            </li>
            <li>
              <span>⏰</span>
              <span>{CONTACT.hours}</span>
            </li>
          </ul>
        </div>

        <nav className="f-links" aria-label="Footer navigation">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="Navbar" spy smooth>Home</Link></li>
            <li><Link to="services" spy smooth>Services</Link></li>
            <li><Link to="works" spy smooth>Experience</Link></li>
            <li><Link to="portfolio" spy smooth>Portfolio</Link></li>
            <li><Link to="testimonial" spy smooth>Testimonials</Link></li>
            <li><Link to="contact" spy smooth>Contact</Link></li>
          </ul>
        </nav>

        <div className="f-social">
          <h4>Follow</h4>
          <div className="f-icons">
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
              <Insta color="white" size="28" />
            </a>
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
              <Facebook color="white" size="28" />
            </a>
            <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer">
              <Linkedin color="white" size="28" />
            </a>
          </div>
        </div>
      </div>

      <div className="f-bottom">
        <span>© {year} Sweven Trading PLC. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
